import { Controller } from "@hotwired/stimulus";

// Pairs a preset button group with an always-editable px number input.
// Buttons fill the input; typing in the input highlights any matching
// preset.
export default class extends Controller {
  static targets = ["button", "input"];

  connect() {
    this.refreshActive();
  }

  select(event) {
    const px = event.currentTarget.dataset.px;
    this.inputTarget.value = px;
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.refreshActive();
  }

  update() {
    this.refreshActive();
  }

  refreshActive() {
    const current = String(this.inputTarget.value || "").trim();
    this.buttonTargets.forEach((button) => {
      const isActive = button.dataset.px === current;
      button.classList.toggle("active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }
}
